import React from 'react';
import { VideoSegment, Segment, ActionTypeColorMap } from './types';

// Component for segment visualization timeline
interface SegmentVisualizationProps {
    segments: VideoSegment[];
    videoDuration: number;
    onSegmentClick: (segment: VideoSegment) => void;
    formatTimeDisplay: (seconds: number) => string;
    videoAnnotationSegments?: Segment[]; // Optional for color mapping
}

const SegmentVisualization: React.FC<SegmentVisualizationProps> = ({
    segments,
    videoDuration,
    onSegmentClick,
    formatTimeDisplay,
    videoAnnotationSegments
}) => {
    
    return (
        <div style={{
            position: 'relative',
            width: '100%',
            minHeight: `${Math.max(20, segments.length * 6)}px`,
            backgroundColor: '#e0e0e0',
            borderRadius: '4px',
            marginBottom: '8px',
            padding: '4px'
        }}>
            {videoDuration > 0 && segments.map((segment, index) => {
                const leftPercent = Math.max(0, Math.min(100, (segment.beginTime / videoDuration) * 100));
                const widthPercent = Math.max(0, Math.min(100 - leftPercent, ((segment.endTime - segment.beginTime) / videoDuration) * 100));
                const topOffset = index * 6; // Stack segments vertically
                
                // Get color from ActionTypeColorMap if videoAnnotationSegments is provided
                //const correspondingSegment = videoAnnotationSegments?.[index];
                const backgroundColor = ActionTypeColorMap[segment.text as keyof typeof ActionTypeColorMap] || '#888888';

                // console.log(`Segment ${segment.id}: ${leftPercent}% left, ${widthPercent}% width, row ${index}, duration: ${videoDuration}s`);

                return (
                    <div
                        key={segment.id}
                        style={{
                            position: 'absolute',
                            left: `${leftPercent}%`,
                            top: `${topOffset}px`,
                            width: `${widthPercent}%`,
                            height: '6px',
                            backgroundColor: backgroundColor,
                            borderRadius: '4px',
                            minWidth: '4px', // Ensure visibility for short segments
                            cursor: 'pointer',
                            border: `1px solid ${backgroundColor}`,
                            filter: 'brightness(0.9)' // Slightly darken the border
                        }}
                        title={`${segment.text} (${formatTimeDisplay(segment.beginTime)} - ${formatTimeDisplay(segment.endTime)})`}
                        onClick={() => onSegmentClick(segment)}
                    />
                );
            })}
        </div>
    );
};

export default SegmentVisualization;